import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { IonicModule } from "@ionic/angular";
import { WatershedsComponent } from "./watersheds.component";
import { TranslateModule } from "@ngx-translate/core";
import { DataCardModule } from "src/app/components/data-card/data-card.module";
import { OrderByWaterLevelModule } from "src/app/pipes/order-by-water-level/order-by-water-level.module";
import { SuppressScrollEventModule } from "src/app/directives/suppress-scroll-event/suppress-scroll-event.module";
import { ShareUrlModule } from "src/app/directives/share-url/share-url.module";
import { ParseValueStationsPipeModule } from "src/app/pipes/parse-value-stations/parse-value-stations.module";
import { OrderByPrecipitationModule } from "../../pipes/order-by-precipitation/order-by-precipitation.module";
import { HidroMeteoSelectorModule } from "../../components/hidrometeo-selector/hidrometeo-selector.module";
import { OrderByAlertLevelModule } from "../../pipes/order-by-alert-level/order-by-alert-level.module";
import { GetValueByDatamodePipeModule } from "../../pipes/get-value-by-datamode/get-value-by-datamode.module";

@NgModule({
  declarations: [WatershedsComponent],
  imports: [
    CommonModule,
    IonicModule,
    TranslateModule,
    DataCardModule,
    OrderByWaterLevelModule,
    OrderByAlertLevelModule,
    SuppressScrollEventModule,
    ShareUrlModule,
    ParseValueStationsPipeModule,
    OrderByPrecipitationModule,
    HidroMeteoSelectorModule,
    GetValueByDatamodePipeModule,
  ],
})
export class WatershedsModule {}
